<template>
  <div class="fillheight">
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
        use-grid
        use-scroll-load
        use-top
      >
        <template #top-append-right>
          <v-text-field
            v-model="params.search"
            clearable
            dense
            hide-details
            outlined
            placeholder="Tìm kiếm theo tên"
            prepend-inner-icon="mdi-magnify"
            single-line
          />
        </template>
        <template #top-right>
          <div class="mr-1 ml-1 d-flex align-center">
            <base-button
              type-action="create"
              @click="onCreateItem()"
            ></base-button>
          </div>
        </template>
        <template #grid-item="{item}">
          <div class="full-width">
            <div class="btn-group justify-between align-center">
              <v-spacer></v-spacer>
              <base-button
                type-action="download"
                icon
                @click.stop="onDownloadItem(item)"
              ></base-button>
              <v-btn
                icon
                color="error"
                @click.stop="onDeleteItem(item)"
                v-if="checkAccess('workspace.delete', item)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </div>
            <v-divider class="mx-1"></v-divider>
          </div>
          <style-item :value="item">
            <div class="pt-2 overflow-hidden full-width">
              <div class="btn-group">
                <base-button
                  class="text-none"
                  small
                  @click.stop="onUpdateItem(item)"
                  color="#00ED64"
                  v-if="checkAccess('style.update', item)"
                >
                  <span>{{ $t('workspace.setting') }}</span>
                </base-button>
              </div>
            </div>
          </style-item>
        </template>
      </base-serve-table>
    </v-sheet>
    <StyleDialog
      ref="dialog_detail"
      @reset="onReset"
      :workspace="workspace"
      disabled-select-workspace
    />
  </div>
</template>

<script>
import StyleDialog from './style-dialog.vue'
import StyleItem from './style-item.vue'
import { API_STYLE } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
export default {
  mixins: [],
  components: {
    StyleItem,
    StyleDialog,
  },
  props: {
    id: [String, Number],
    workspace: { type: Object, default: () => ({}) },
  },
  data: (vm) => ({
    default_params: {
      workspace_id: vm.id,
      with: 'workspace,layer',
    },
    params: { search: '', inactive: null },
    menus: [
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('workspace.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('workspace.delete', item),
      },
    ],
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'center',
      },
    ],
    loading: false,
    resource_headers: [
      {
        trans: 'datastore.layer.name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        trans: 'datastore.layer.action',
        align: 'start',
        sortable: false,
        value: 'action',
      },
    ],
    resource_default_params: {},
    resource_params: { search: '', inactive: null },
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_STYLE
    },
  },
  created() {},
  mounted() {},
  methods: {
    onDownloadItem(item) {
      API_STYLE.download(item.id)
    },
    onGotoDetail(item) {
      this.$refs.dialog_detail.open(item, EDIT_TYPE.UPDATE)
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addText(
          'Hành động này sẽ cài đặt lại trình bày bản đồ của lớp bản đồ về mặc định'
        )
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await this.api.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onCreateItem() {
      this.$refs.dialog_detail.open(
        {
          workspace_id: this.id,
        },
        EDIT_TYPE.UPDATE
      )
    },
    onUpdateItem(item) {
      this.$refs.dialog_detail.open(item, EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
  },
}
</script>
